import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IImageFile } from 'interfaces/files';
import { IOptionType } from 'interfaces/forms';

export const prefix = `${BUSINESS_TOOL_SECTIONS.OVERVIEW}.${BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY}` as const;

export const COMPANY_OVERVIEW_NAMES = {
  FILE: 'file',
  LIFE_CYCLE_STAGES: 'lifeCycleStages',
} as const;

export interface ICompanyOverviewForm {
  [COMPANY_OVERVIEW_NAMES.FILE]: IImageFile[];
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: IOptionType[];
}

export const overviewCompanyInitialValues: ICompanyOverviewForm = {
  [COMPANY_OVERVIEW_NAMES.FILE]: [],
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: [],
};
